<template>
    <div
        data-dialog="true"
        id="printQuoteDialog"
        class="flex flex-col relative w-[885px] print:w-full h-full bg-gray-tier-3"
    >
        <header class="sticky top-0 bg-gray-tier-2 border-b border-keyline-primary">
            <div class="w-full flex items-center justify-between py-2 px-6 print:px-0">
                
                <div class="flex items-center gap-4">
                    <h2>
                        {{ $t("Quote #") }}
                        <span class="font-medium">{{ data }}</span>
                    </h2>
                </div>
                <span class="print:hidden flex items-center justify-end gap-2">
                    <AppButton @click="toggleEmailQuoteDialog($event, {id:data})" icon="icon-email-envelope" text="Email" />
                    <DialogCloseButton />
                </span>
            </div>
        </header>
        <div
            v-if="quote"
            class="overflow-y-auto mt-[49px] relative"
            :class="scrollClasses"
            @scroll="handleScroll"
        >
            <RecordHeader :record="quote" class="px-6 print:px-0 py-3 !fixed top-[51px] w-full type-secondary bg-gray-tier-2 border-b border-keyline-primary" />
            <QuoteCustomerInfo :quote="quote" fromDialog="true" :salesData="salesData" />
            <QuoteRecord v-bind="props" :fromDialog="true" :salesData="salesData" :cards="cards" class="p-6 print:px-0 mb-8" />
        </div>
        <div v-else class="print:hidden absolute inset-0 flex items-center justify-center">
            <LoadingSpinner :large="true"/>
        </div>
    </div>
</template>

<script setup>
import {
    DialogCloseButton,
    LoadingSpinner,
    QuoteRecord,
    RecordHeader,
    AppButton,
    QuoteCustomerInfo,
} from "@/Components";
import {useEmailQuoteDialog, useScroll} from '@/Composables';

const { toggleEmailQuoteDialog } = useEmailQuoteDialog();
const { scrollClasses, handleScroll } = useScroll();

const props = defineProps(["data", "quote", "isLoading", "columns", "rows", "salesData", "cards"]);

</script>
